import React, { Component } from 'react';

import { FormattedHTMLMessage } from 'react-intl';
import { Row, Col, Checkbox } from 'react-bootstrap';

import FullScreenTemplate from './FullScreenTemplate.js';
import Header from './Header.js';

require(`../assets/${process.env.PAGE}/css/components/DDJJWarningModal.css`)


class DDJJWarningModal extends Component {

    constructor(props){
        super(props);
        this.state = {
            checkedTos: false,
            acceptDdjj: false,
        };

        this.handleSubmit = this.handleSubmit.bind(this);
        this.checkTos = this.checkTos.bind(this);
    }

    handleSubmit(event) {
        event.preventDefault();
        this.setState({
            acceptDdjj: true
        });
    }

    checkTos(event){
        this.setState({
            checkedTos: event.target.checked
        });
    }

    render() {
        const { checkedTos, acceptDdjj } = this.state;

        const modal = (
            <FullScreenTemplate>
                <div className="row">
                        <Header>
                            <FormattedHTMLMessage
                                id="app.intro"
                                defaultMessage="<h6>Financiá tu PyME en Vendimia, es fácil.</h6>"
                                description="Introducción"/>
                        </Header>
                        <div className="pd-content-bottom col-sm-12 col-md-8 col-lg-8 col-md-offset-2 col-lg-offset-2 text-center">
                            <div>
                                <form onSubmit={this.handleSubmit} className='pvc-form'>
                                    <Row>
                                        <Col className='text-center' lg={12}>
                                            <FormattedHTMLMessage
                                                id="app.step_start"
                                                description="Start"/>
                                            <FormattedHTMLMessage
                                                id="app.step_ddjj"
                                                description="DDJJ"/>
                                        </Col>
                                    </Row>
                                    <Row className="terms_row">
                                        <Col className=" text-center" xs={12} md={12} lg={12}>
                                            <Checkbox checked={checkedTos} onClick={this.checkTos}>{'Acepto Términos y Condiciones'}</Checkbox>
                                        </Col>
                                    </Row>
                                    <button type="submit" className="btn btn-warning btn-lg pd-button pd-form loan" disabled={!checkedTos}>Aceptar</button>
                                </form>
                            </div>
                        </div>
                </div>
            </FullScreenTemplate>
        );

        return !acceptDdjj ? modal : null;
    }
}

export default DDJJWarningModal;



/** WEBPACK FOOTER **
 ** ./src/components/DDJJWarningModal.js
 **/